module.exports = __webpack_public_path__ + "img/ico-addr.95fc5c8d.png";